module.exports = __webpack_public_path__ + "static/img/achieve_back2.c1e62ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achieve_back2.png
// module id = 55zA
// module chunks = 167